import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
// import {AddPaymentMethodModalComponent} from "./components/add-payment-method-modal/add-payment-method-modal.component";
import {NewPaymentComponent} from "./components/new-payment/new-payment.component";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {FormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ErrorsModule} from "../widgets/errors/errors.module";
import {FullPageSpinnerComponent} from "../full-page-spinner/full-page-spinner.component";
import {MatButtonModule} from "@angular/material/button";

@NgModule({
    declarations: [
        // AddPaymentMethodModalComponent,
        NewPaymentComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        FontAwesomeModule,
        ErrorsModule,
        FullPageSpinnerComponent,
        MatButtonModule,
    ],
    exports: [
        // AddPaymentMethodModalComponent,
        NewPaymentComponent,
    ]
})
export class PaymentModule {
}
